<template>
  <div>
    <main class="main" role="main">
      <div class="main_con">
        <h1 class="con_ttl">{{ userProfile.nickname }}님<br />방갑습니다 :)</h1>
        <img
          class="img start"
          src="@/assets/front/images/img_start.png"
          alt=""
        />
        <div class="msg">
          <div>퍼스는 내가 활동하는 지역의</div>
          <div>휴대폰 매장들과 거래를 하기 위해</div>
          <div>만들어진 서비스입니다.</div>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button class="btn" @click="gotoRegionSetting">
            우리동네 등록하고 시작하기
          </button>
        </div>
      </div>
    </main>
    <GPSUseConfirmModal
      v-if="gpsUseModal"
      @close="hideGpsUseModal"
      @setting="openSetting"
    ></GPSUseConfirmModal>
    <GPSOffModal
      v-if="gpsOffModal"
      @close="hideGpsOffModal"
      @setting="openSetting"
    ></GPSOffModal>
  </div>
</template>

<script>
import GPSUseConfirmModal from '@/front/customer/views/auth/modal/GPSUseConfirmModal';
import GPSOffModal from '@/front/customer/views/auth/modal/GPSOffModal';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  isApp,
  sleep,
  clearLocation,
  nativeLocation,
  nativeGoToSetting,
} from '@common/lib/common/utils';

export default {
  components: { GPSOffModal, GPSUseConfirmModal },
  created() {
    this.handleLocation();
    this.fetchMe();
  },
  data() {
    return {
      isFirst: true,
      gpsUseModal: false,
      gpsOffModal: false,
      checkerId: -1,
      latitude: 0,
      longitude: 0,
    };
  },
  computed: {
    ...userMapGetters({
      userProfile: userTypes.USER,
    }),
  },
  beforeDestroy() {
    if (this.checkerId !== -1) {
      clearInterval(this.checkerId);
      this.checkerId = -1;
    }
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    fetchMe() {
      this[userTypes.FETCH_ME]();
    },
    startChecker() {
      if (this.checkerId === -1) {
        this.checkerId = setInterval(() => {
          if (window.$bridge.location.code === '1') {
            alert(window.$bridge.location.code);
            this.hideGpsOffModal();
            this.hideGpsUseModal();
          }
        }, 1000);
      }
    },
    hideGpsUseModal() {
      this.gpsUseModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    hideGpsOffModal() {
      this.gpsOffModal = false;
      if (this.checkerId !== -1) {
        clearInterval(this.checkerId);
        this.checkerId = -1;
      }
    },
    showGpsUseModal() {
      this.gpsUseModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    showGpsOffModal() {
      this.gpsOffModal = true;
      if (this.checkerId === -1) {
        this.startChecker();
      }
    },
    openSetting() {
      if (!isApp()) {
        this.getLocation();
      } else {
        // 네이티브 앱 위치설정 열기
        nativeGoToSetting(2);
      }
    },
    // 위치정보 확인 후 동네설정으로 이동
    gotoRegionSetting() {
      this.handleLocation();
    },
    async handleLocation() {
      // 앱이 아닌 경우
      if (!isApp()) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then(permissionStatus => {
            console.log(permissionStatus.state.toString());

            switch (permissionStatus.state.toString()) {
              case 'prompt':
                if (!this.isFirst) this.showGpsUseModal();
                break;
              case 'denied':
                if (!this.isFirst) this.showGpsOffModal();
                break;
              case 'granted':
                if (!this.isFirst) this.$router.push({ name: 'Auth.Region' });
                break;
              default:
                //this.$router.push({ name: 'Auth.Region' });
                break;
            }

            this.isFirst = false;
          });
      }
      // 앱인 경우
      else {
        clearLocation();
        nativeLocation();
        await sleep(1000);
        if (window.$bridge.location.code !== undefined) {
          // GPS 켜져있을때 : 1, 꺼져있을 때 -1
          if (window.$bridge.location.code === '1') {
            this.hideGpsOffModal();
            this.hideGpsUseModal();
            if (!this.isFirst) await this.$router.push({ name: 'Auth.Region' });
          } else {
            this.showGpsOffModal();
          }
          this.isFirst = false;
        } else {
          if (!this.isFirst) this.showGpsUseModal();
          this.isFirst = false;
        }
      }
    },

    getLocation() {
      if (navigator.geolocation) {
        return new Promise(() => {
          navigator.geolocation.getCurrentPosition(
            this.showPosition,
            this.showError,
          );
        });
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    },

    showPosition(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
    },

    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log('User denied the request for Geolocation.');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('Location information is unavailable.');
          break;
        case error.TIMEOUT:
          console.log('The request to get user location timed out.');
          break;
        case error.UNKNOWN_ERROR:
          console.log('An unknown error occurred.');
          break;
      }
    },
  },
};
</script>
